import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    border: `1px solid ${theme.border.outline}`,
    marginRight: '1rem',
    textTransform: 'capitalize',
    padding: '0.25rem',
    borderRadius: '5px',
    display: 'flex',
    alignItems: 'center',
    fontSize: theme.size.sm
  },

  icon: {
    height: '1rem',
    width: '1rem'
  },

  name: {
    display: 'flex',
    alignItems: 'center',

    '& div': {
      marginLeft: '0.5rem',
      opacity: '0.35',
      fontStyle: 'italic'
    }
  }
}))

export default useStyles
